import React, { Suspense } from 'react';
import { Analytics } from '@vercel/analytics/react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Footer from './components/footer';
import { routes } from './routes/config';
import { Helmet } from 'react-helmet';
import NotFound from './pages/notfound';
import { SpeedInsights } from '@vercel/speed-insights/react';

const App: React.FC = () => {
	return (
		<BrowserRouter>
			<Analytics />
			<SpeedInsights />
			<section className="app">
				<main>
					<article>
						<Suspense fallback={<div>Loading...</div>}>
							<Routes>
								{routes.map(({ path, component: Component, meta }) => (
									<Route
										key={path}
										path={path}
										element={
											<>
												<Helmet>
													<title>{meta?.title}</title>
													<meta
														name="description"
														content={meta?.description}
													/>
												</Helmet>
												<Component />
											</>
										}
									/>
								))}
								<Route path="*" element={<NotFound />} />
							</Routes>
						</Suspense>
					</article>
				</main>
				<Footer />
			</section>
		</BrowserRouter>
	);
};

export default App;
